// extracted by mini-css-extract-plugin
export default {"location__list":"InfoList_location__list__SSD62","active":"InfoList_active__irnvq"};